import React, { createContext, useContext, useState, useCallback } from "react";
import en from "../locales/en.json";
import ja from "../locales/ja.json";

const dictionaries = { en, ja };
const LocalizationContext = createContext(null);

function lookup(dict, key) {
  return key.split(".").reduce((acc, part) => (acc && acc[part] !== undefined ? acc[part] : undefined), dict);
}

export function LocalizationProvider({ children }) {
  const [language, setLanguageState] = useState(
    localStorage.getItem("yoko_lang") || process.env.REACT_APP_DEFAULT_LANGUAGE || "en"
  );

  const setLanguage = useCallback((lang) => {
    localStorage.setItem("yoko_lang", lang);
    setLanguageState(lang);
  }, []);

  const t = useCallback(
    (key, vars) => {
      const dict = dictionaries[language] || dictionaries.en;
      const value = lookup(dict, key);
      let result = value !== undefined ? value : lookup(dictionaries.en, key);
      if (result === undefined) return key;
      if (vars && typeof result === "string") {
        Object.entries(vars).forEach(([k, v]) => {
          result = result.replace(`{${k}}`, v);
        });
      }
      return result;
    },
    [language]
  );

  return (
    <LocalizationContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LocalizationContext.Provider>
  );
}

export function useLocalization() {
  return useContext(LocalizationContext);
}
